import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import CONFIG from '../config';

const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    const [branding, setBranding] = useState(null);
    const [variables, setVariables] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchBrandingData = async () => {
        try {
            // Fetch both branding and variables
            const [brandingRes, variablesRes] = await Promise.all([
                axios.get(`${CONFIG.API_URL}/api/branding`),
                axios.get(`${CONFIG.API_URL}/api/branding/variables`)
            ]);

            if (brandingRes.data) {
                setBranding(brandingRes.data);
                window.__BRANDING__ = brandingRes.data;

                // Inject CSS variables
                const root = document.documentElement;
                if (brandingRes.data.colors) {
                    Object.entries(brandingRes.data.colors).forEach(([key, value]) => {
                        const cssVar = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
                        if (value) root.style.setProperty(cssVar, value);
                    });
                }
                if (brandingRes.data.ui) {
                    Object.entries(brandingRes.data.ui).forEach(([key, value]) => {
                        const cssVar = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
                        if (value) root.style.setProperty(cssVar, value);
                    });
                }
                if (brandingRes.data.fonts) {
                    Object.entries(brandingRes.data.fonts).forEach(([key, value]) => {
                        const cssVar = `--font-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
                        if (value) root.style.setProperty(cssVar, value);
                    });
                }

                // Handle default language
                if (brandingRes.data.defaultLanguage) {
                    const savedLang = localStorage.getItem('i18nextLng');
                    // Only override if user hasn't manually changed it (optional logic)
                    // Or just always follow tenant default on first load? 
                    // Let's follow tenant default if it's explicitly set and no user preference exists.
                    if (!savedLang || savedLang.length < 2) {
                        import('../i18n').then(i18n => {
                            i18n.default.changeLanguage(brandingRes.data.defaultLanguage);
                        });
                    }
                }
            }

            if (variablesRes.data) {
                setVariables(variablesRes.data);
            }
        } catch (err) {
            console.error('Failed to load branding data:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBrandingData();

        window.addEventListener('branding_updated', fetchBrandingData);
        return () => window.removeEventListener('branding_updated', fetchBrandingData);
    }, []);

    return (
        <BrandingContext.Provider value={{ branding, variables, loading, refreshBranding: fetchBrandingData }}>
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => useContext(BrandingContext);
